import getters from './getter.js';
const state = {
	isShow: true,
	isNavShow: true,
	isLogin: false,
	username: '',
	starnum: 0,
	focusnum: 0,
	fannum: 0,
	fabunum: 0,
	sellnum: 0,
	buynum: 0,
	money: 0,
	likenum: 0,
	goodstitle: '',
	goodsinfo: '',
	imgUrl: '',
	price: '',
	kind: '',
	primecost: '',
	freight: '',
	news: '',
	addr: {},
	buyinfo: [],
	curindex: 0,
	fabuinfo: [],
	show: true,
	userinfo: {},
	db:{},
  websocket:{},
  token:'',
  pages:1,
  isAddPage:false,
  brand:'',
  carForme:'',
  borneMill:'',
  carAge:'',
  displacement:'',
  fuelType:'',
  seatNum:'',
  chatMsg:{},
  sendSingleMsgUnsucce:{},
  sendSingleMsgUnerror:{},
  wChatUserId:'',
  audio:null,
  chatMsgs:[],
  dtask:null,
  downTotal:'',
  carUserId:'',
  zhouseTypeIndex:'',
  zhouseId:'',
  oldCurrAddr:{},
  currAddr:'',
  pageTag:'',
  find:{},
  lat:'',
  lgt:'',
  wx:{},
  chatMsgNum: 0
}
const mutations = {
	setShow: (state, bool) =>{
		state.show = bool
	},
	setCurindex: (state, index) => {
		state.curindex = index
	},
	showNav: (state) => {
		state.isNavShow = true
	},
	hideNav: (state) => {
		state.isNavShow = false
	},
	hasLogin: (state) => {
		state.isLogin = true
	},
	noLogin: (state) => {
		state.isLogin = false
	},
	setUsername: (state, username) => {
		state.username = username
	},
	setStarnum: (state) => {
		console.log('加')
		state.starnum = state.starnum +1
	},
	cutStarnum: (state) => {
		console.log('减')
		state.starnum --
	},
	setFocusnum: (state) => {
		state.focusnum ++
	},
	cutFocusnum: (state) => {
		state.focusnum --
	},
	setFannum: (state) => {
		state.fannum ++
	},
	cutFannum: (state) => {
		state.fannum --
	},
	setFabunum: (state) => {
		state.fabunum ++
	},
	cutFabunum: (state) => {
		state.fabunum --
	},
	setSellnum: (state) => {
		state.sellnum ++
	},
	cutSellnum: (state) => {
		state.sellnum --
	},
	setBuynum: (state) => {
		state.buynum ++
	},
	cutBuynum: (state) => {
		state.buynum --
	},
	setLikenum: (state) => {
		state.likenum ++
	},
	cutLikenum: (state) => {
		state.likenum --
	},
	setGoodstilte: (state, goodstitle) => {
		state.goodstitle = goodstitle
	},
	setGoodsinfo: (state, goodsinfo) => {
		state.goodsinfo = goodsinfo
	},
	setImgurl: (state, imgurl) => {
		state.imgurl = imgurl
	},
	setPrice: (state, price) => {
		state.price = price
	},
	setKind: (state, showkind) => {
		state.showkind == showkind
	},
	setPrimecost: (state, primecost) => {
		state.primecost = primecost
	},
	setFreight: (state, freight) => {
		state.freight = freight
	},
	setNews: (state, news) => {
		state.news = news
	},
	setAddr: (state, addr) => {
		state.addr = addr
	},
	setBuyinfo: (state, info) => {
		state.buyinfo.push(info)
		console.log(state.buyinfo)
	},
	cutBuyinfo: (state, index) => {
		state.buyinfo.splice(index,1)
		state.buynum--
		console.log(state.buyinfo)
	},
	setFabuinfo: (state, info) => {
		state.fabuinfo.push(info)
		console.log(state.fabuinfo)
	},
	cutFabuinfo: (state, index) => {
		state.fabuinfo.splice(index,1)
		state.fabunum--
		console.log(state.fabuinfo)
	},
	setReceive: (state, obj) => {
		console.log(obj.receive,obj.index)
		console.log(state.buyinfo[obj.index].receive)
		state.buyinfo[obj.index].receive = obj.receive
		console.log(state.buyinfo[obj.index].receive)
	},
	setDel: (state, obj) => {
		console.log(state.buyinfo[obj.index])
		state.buyinfo[obj.index].del = obj.del
		console.log(state.buyinfo[obj.index].del)
	},
	setUserinfo: (state, userinfo) =>{
		window.localStorage.setItem('useravatar',userinfo.avatar)
		state.userinfo = userinfo
		console.log(state.userinfo)
	}
	,setToken:(state,token)=>{
    state.token = token
  }
  ,setWChatUserId:(state,wChatUserId)=>{
    state.wChatUserId = wChatUserId
  }
  ,addPages:(state)=>{
	  state.pages++
  }
  ,setPages:(state,pages)=>{
    state.pages = pages
  }
  ,setIsAddPage:(state)=>{
	  state.isAddPage = true
  }
  ,reSetIsAddPage:(state)=>{
    state.isAddPage = false
  }
	,setDb:(state, db) =>{
    state.db = db
  },
  setWebsocket:(state,websocket) =>{
	  state.websocket = websocket
  },
  setBrand:(state,brand) => {
    state.brand = brand
  },
  setCarForme:(state,carForme)=>{
	  state.carForme = carForme
  },
  setBorneMill:(state,borneMill)=>{
	  state.borneMill = borneMill
  },
  setCarAge:(state,carAge)=>{
	  state.carAge = carAge
  },
  setDisplacement:(state,displacement)=>{
	  state.displacement = displacement
  },
  setFuelType:(state,fuelType)=>{
	  state.fuelType = fuelType
  },
  setSeatNum:(state,seatNum)=>{
	  state.seatNum = seatNum
  },
  setChatMsg:(state,chatMsg) =>{
    state.chatMsg = chatMsg
  },
  setSendSingleMsgUnsucce:(state,sendSingleMsgUnsucce) =>{
	  state.sendSingleMsgUnsucce = sendSingleMsgUnsucce
  },setSendSingleMsgUnerror:(state,sendSingleMsgUnerror) =>{
	  state.sendSingleMsgUnerror = sendSingleMsgUnerror
  },setAudio:(state,audio)=>{
    state.audio = audio
  },setChatMsgs:(state,chatMsgs)=>{
	  state.chatMsgs = chatMsgs
  },setDtask:(state,dtask)=>{
    state.dtask = dtask
  },setDownTotal:(state,downTotal)=>{
    state.downTotal = downTotal
  },setCarUserId:(state,carUserId)=>{
	  state.carUserId = carUserId
  },setZhouseTypeIndex:(state,zhouseTypeIndex)=>{
    state.zhouseTypeIndex = zhouseTypeIndex
  },setZhouseId:(state,zhouseId)=>{
	  state.zhouseId = zhouseId
  },setOldCurrAddr:(state,oldCurrAddr)=>{
	  state.oldCurrAddr = oldCurrAddr
  },setCurrAddr:(state,currAddr)=>{
    state.currAddr = currAddr
  },setPageTag:(state,pageTag)=>{
	  state.pageTag = pageTag
  },setFind:(state,find)=>{
    state.find = find
  },setLat:(state,lat)=>{
	  state.lat = lat
  },setLgt:(state,lgt)=>{
    state.lgt = lgt
  },setWx:(state,wx)=>{
    state.wx = wx
  },setChatMsgNum:(state,chatMsgNum)=>{
	  state.chatMsgNum = chatMsgNum
  }
}
export default {
	getters,
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/mutation.js